import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=87c44f20&lang=pug"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=87c44f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports